import React, { useEffect, useState } from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Button,
  Paper,
  Container,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Grid,
  Card,
  CardContent,
  CardMedia,
  AppBar,
  Toolbar,
  Fade,
  CircularProgress,
  Alert,
  Divider,
  FormHelperText,
  Radio,
  RadioGroup
} from '@mui/material';
import {
  CloudUpload,
  Download,
  Send,
  AccountCircle,
  Description,
  VerifiedUser,
  Article
} from '@mui/icons-material';
import axios from 'axios';
import { db } from "../firebase";
// import { collection, addDoc } from "firebase/firestore";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
// Define form field configurations for different form types
const formConfigurations = {
  // 'membership': {
  //   title: 'Membership Application',
  //   fields: [
  //     { name: 'firstName', label: 'First Name', type: 'text', required: true },
  //     { name: 'lastName', label: 'Last Name', type: 'text', required: true },
  //     { name: 'email', label: 'Email', type: 'email', required: true },
  //     { name: 'phone', label: 'Phone Number', type: 'text', required: true },
  //     { name: 'address', label: 'Address', type: 'text', required: true },
  //     { name: 'pincode', label: 'Pincode', type: 'text', required: true },
  //     {
  //       name: 'membershipType', label: 'Membership Type', type: 'select', required: true,
  //       options: ['Basic', 'Premium', 'Gold']
  //     },
  //   ],
  //   amount: 599
  // },
  'shareholder': {
    title: 'Shareholder Registration',
    fields: [
      { name: 'fullName', label: 'Full Name (in BLOCK letters)', type: 'text', required: true },
      { name: 'age', label: 'Age', type: 'number', required: true },
      { name: 'dob', label: 'Date of Birth', type: 'date', required: true },
      { name: 'guardianName', label: "Father's/Husband's Name", type: 'text', required: true },
      { name: 'presentAddress', label: 'Present Address', type: 'text', required: true },
      { name: 'permanentAddress', label: 'Permanent Address', type: 'text', required: true },
      { name: 'phone', label: 'Telephone/Mobile Number', type: 'text', required: true },
      { name: 'idNumber', label: 'PAN/Aadhaar Card Number', type: 'text', required: true },
      { name: 'email', label: 'Email ID', type: 'email', required: true },
      { name: 'nomineeName', label: 'Nominee Name', type: 'text', required: true },
      { name: 'nomineeRelation', label: 'Relation with Member', type: 'text', required: true },
      { name: 'noOfShares', label: 'No. of Shares (₹100 per share)', type: 'number', required: true }
    ],
    amount: 1000
  },
  'Registrationforevent': {
    title: 'events - edp(entrepreneurship development program) seminar- workshop , edp- training program ',
    fields: [
      { name: 'fullName', label: 'Full Name (in BLOCK letters)', type: 'text', required: true },
      { name: 'age', label: 'Age', type: 'number', required: true },
      { name: 'dob', label: 'Date of Birth', type: 'date', required: true },
      { name: 'guardianName', label: "Father's/Husband's Name", type: 'text', required: true },
      { name: 'qualification', label: "Qualification", type: 'text', required: true },
      { name: 'experince', label: "Professional Experince", type: 'text', required: true },
      { name: 'reason', label: "Why you want to join?", type: 'text', required: true },
      { name: 'presentAddress', label: 'Present Address', type: 'text', required: true },
      { name: 'permanentAddress', label: 'Permanent Address', type: 'text', required: true },
      { name: 'phone', label: 'Telephone/Mobile Number', type: 'text', required: true },
      { name: 'idNumber', label: 'PAN/Aadhaar Card Number', type: 'text', required: true },
      { name: 'email', label: 'Email ID', type: 'email', required: true },
      { name: 'nomineeName', label: 'Nominee Name', type: 'text', required: true },
      { name: 'nomineeRelation', label: 'Relation with Member', type: 'text', required: true },
      { name: 'noOfShares', label: 'No. of Shares (₹100 per share)', type: 'number', required: true }
    ],
    amount: 500
  },
  'knowledgepartnersmember': {
    title: 'Knowledge Partner Form Application',
    fields: [
      { name: 'fullName', label: 'Full Name (in BLOCK letters)', type: 'text', required: true },
      { name: 'age', label: 'Age', type: 'number', required: true },
      { name: 'dob', label: 'Date of Birth', type: 'date', required: true },
      { name: 'guardianName', label: "Father's/Husband's Name", type: 'text', required: true },
      { name: 'profession', label: "Profession", type: 'text', required: true },
      { name: 'experince', label: "Professional Experince", type: 'text', required: true },
      // { name: 'reason', label: "Why you want to join?", type: 'text', required: true },
      { name: 'presentAddress', label: 'Present Address', type: 'text', required: true },
      { name: 'permanentAddress', label: 'Permanent Address', type: 'text', required: true },
      { name: 'phone', label: 'Telephone/Mobile Number', type: 'text', required: true },
      { name: 'idNumber', label: 'PAN/Aadhaar Card Number', type: 'text', required: true },
      { name: 'email', label: 'Email ID', type: 'email', required: true },
      { name: 'nomineeName', label: 'Nominee Name', type: 'text', required: true },
      { name: 'nomineeRelation', label: 'Relation with Member', type: 'text', required: true },
      // { name: 'noOfShares', label: 'No. of Shares (₹100 per share)', type: 'number', required: true }
    ],
    amount: 1200
  },

  // 'account': {
  //   title: 'Account Opening Form',
  //   fields: [
  //     { name: 'firstName', label: 'First Name', type: 'text', required: true },
  //     { name: 'lastName', label: 'Last Name', type: 'text', required: true },
  //     { name: 'email', label: 'Email', type: 'email', required: true },
  //     { name: 'phone', label: 'Phone Number', type: 'text', required: true },
  //     { name: 'address', label: 'Address', type: 'text', required: true },
  //     {
  //       name: 'idProof', label: 'ID Proof Type', type: 'select', required: true,
  //       options: ['Aadhar Card', 'Passport', 'Driving License']
  //     },
  //     { name: 'idNumber', label: 'ID Number', type: 'text', required: true },
  //     { name: 'nomineeName', label: 'Nominee Name', type: 'text', required: true },
  //   ],
  //   amount: 250
  // },
  'student': {
    title: 'Student Membership Form',
    fields: [
      { name: 'firstName', label: 'First Name', type: 'text', required: true },
      { name: 'lastName', label: 'Last Name', type: 'text', required: true },
      { name: 'email', label: 'Email', type: 'email', required: true },
      { name: 'dob', label: 'Date of Birth', type: 'date', required: true },
      { name: 'phone', label: 'Phone Number', type: 'text', required: true },
      { name: 'address', label: 'Address', type: 'text', required: true },
      { name: 'instituteName', label: 'Institute Name', type: 'text', required: true },
      { name: 'course', label: 'Course', type: 'text', required: true },
      { name: 'studentId', label: 'Student ID', type: 'text', required: true },
      { name: 'graduationYear', label: 'Expected Graduation Year', type: 'number', required: true },
    ],
    amount: 500
  }
};
// FormTypeSelection component
const FormTypeSelection = ({ formType, setFormType, termsAccepted, setTermsAccepted, handleNext }) => {
  const [formTypeError, setFormTypeError] = useState('');
  const [termsError, setTermsError] = useState('');

  const validateAndProceed = () => {
    let isValid = true;

    if (!formType) {
      setFormTypeError('Please select a form type');
      isValid = false;
    } else {
      setFormTypeError('');
    }

    if (!termsAccepted) {
      setTermsError('You must accept the terms and conditions');
      isValid = false;
    } else {
      setTermsError('');
    }

    if (isValid) {
      handleNext();
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom>
        Select Form Type
      </Typography>

      <FormControl fullWidth error={!!formTypeError} sx={{ mt: 2, mb: 3 }}>
        <InputLabel id="form-type-label">Form Type</InputLabel>
        <Select
          labelId="form-type-label"
          id="form-type"
          value={formType}
          label="Form Type"
          onChange={(e) => setFormType(e.target.value)}
        >
          {/* <MenuItem value="membership">Membership Form</MenuItem> */}
          <MenuItem value="shareholder">Shareholder Form</MenuItem>
          {/* <MenuItem value="account">Account Opening Form</MenuItem> */}
          <MenuItem value="student">Student Member Form</MenuItem>
          <MenuItem value="Registrationforevent">Registration for event</MenuItem>
          <MenuItem value="knowledgepartnersmember">Knowledge Partner Form Application</MenuItem>

        </Select>
        {formTypeError && <FormHelperText>{formTypeError}</FormHelperText>}
      </FormControl>

      <Box sx={{ bgcolor: '#f5f5f5', p: 2, my: 3, borderRadius: 1 }}>
        <Typography variant="h6" gutterBottom>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          By accepting these terms, you acknowledge that:
        </Typography>
        <Typography variant="body2" component="div">
          <ul>
            <li>All information provided by you is accurate and complete.</li>
            <li>You agree to the collection and processing of your personal information.</li>
            <li>You will comply with all applicable rules and regulations.</li>
            <li>Application fees paid are non-refundable once processed.</li>
            {/* <li>The company reserves the right to reject applications without providing reasons.</li> */}
          </ul>
        </Typography>
      </Box>

      <FormControl error={!!termsError}>
        <FormControlLabel
          control={
            <Checkbox
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
            />
          }
          label="I accept the terms and conditions"
        />
        {termsError && <FormHelperText>{termsError}</FormHelperText>}
      </FormControl>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={validateAndProceed}
          sx={{
            bgcolor: '#0A2472',
            '&:hover': { bgcolor: '#061551' }
          }}
        >
          Continue
        </Button>
      </Box>
    </Paper>
  );
};

// Reusable form component
const FormComponent = ({ formType, formData, setFormData, handleNext }) => {
  const config = formConfigurations[formType];
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    config.fields.forEach(field => {
      if (field.required && !formData[field.name]) {
        newErrors[field.name] = `${field.label} is required`;
        isValid = false;
      }

      if (field.type === 'email' && formData[field.name]) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(formData[field.name])) {
          newErrors[field.name] = 'Please enter a valid email address';
          isValid = false;
        }
      }

      if (field.name === 'phone' && formData[field.name]) {
        const phonePattern = /^\d{10}$/;
        if (!phonePattern.test(formData[field.name])) {
          newErrors[field.name] = 'Please enter a valid 10-digit phone number';
          isValid = false;
        }
      }

      if (field.name === 'pincode' && formData[field.name]) {
        const pincodePattern = /^\d{6}$/;
        if (!pincodePattern.test(formData[field.name])) {
          newErrors[field.name] = 'Please enter a valid 6-digit pincode';
          isValid = false;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handleNext();
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom>
        {config.title}
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {config.fields.map((field) => (
            <Grid item xs={12} sm={field.name === 'address' ? 12 : 6} key={field.name}>
              {field.type === 'select' ? (
                <FormControl fullWidth error={!!errors[field.name]}>
                  <InputLabel id={`${field.name}-label`}>{field.label}</InputLabel>
                  <Select
                    labelId={`${field.name}-label`}
                    id={field.name}
                    name={field.name}
                    value={formData[field.name] || ''}
                    label={field.label}
                    onChange={handleChange}
                    required={field.required}
                  >
                    {field.options.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                  {errors[field.name] && <FormHelperText>{errors[field.name]}</FormHelperText>}
                </FormControl>
              ) : (
                <TextField
                  id={field.name}
                  name={field.name}
                  label={field.label}
                  type={field.type}
                  fullWidth
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                  required={field.required}
                  error={!!errors[field.name]}
                  helperText={errors[field.name]}
                  variant="outlined"
                  InputLabelProps={field.type === 'date' ? { shrink: true } : {}}
                />

              )}
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            onClick={() => handleNext(true)}
            sx={{
              borderColor: '#0A2472',
              color: '#0A2472',
              '&:hover': { borderColor: '#061551', color: '#061551' }
            }}
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              bgcolor: '#0A2472',
              '&:hover': { bgcolor: '#061551' }
            }}
          >
            Continue
          </Button>
        </Box>
      </form>
    </Paper>
  );
};
//  Document Upload section
const DocumentType = ({ formType, formData, setFormData, handleNext }) => {
  const [errors, setErrors] = useState({});

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    setFormData({ ...formData, [field]: file });
    setErrors({ ...errors, [field]: '' }); // Clear error on change
  };

  const validateForm = () => {
    const newErrors = {};

    // Define the base required fields
    let requiredFields = ['photo', 'idProof', 'addressProof', "signature"];

    // Include 'panCard' only if formType is not 'student'
    if (formType !== 'student') {
      requiredFields.push('panCard');
    }

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = 'Please upload a valid document.';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handleNext();
    }
  };
  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom>
        Upload Required Documents
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">Passport Size Photo</Typography>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, 'photo')}
              style={{ marginTop: '8px' }}
            />
            {errors.photo && (
              <FormHelperText error>{errors.photo}</FormHelperText>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">ID Proof (Aadhar, PAN, DL, Passport)</Typography>
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={(e) => handleFileChange(e, 'idProof')}
              style={{ marginTop: '8px' }}
            />
            {errors.idProof && (
              <FormHelperText error>{errors.idProof}</FormHelperText>
            )}
          </Grid>
          {/* signature input */}
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">Signature(clear)</Typography>
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={(e) => handleFileChange(e, 'signature')}
              style={{ marginTop: '8px' }}
            />
            {errors.idProof && (
              <FormHelperText error>{errors.idProof}</FormHelperText>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">Address Proof (Aadhar, Electricity Bill, DL)</Typography>
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={(e) => handleFileChange(e, 'addressProof')}
              style={{ marginTop: '8px' }}
            />
            {errors.addressProof && (
              <FormHelperText error>{errors.addressProof}</FormHelperText>
            )}
          </Grid>
          {formType !== "student" && <>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1">PAN Card</Typography>
              <input
                type="file"
                accept="image/*,.pdf"
                onChange={(e) => handleFileChange(e, 'panCard')}
                style={{ marginTop: '8px' }}
              />
              {errors.panCard && (
                <FormHelperText error>{errors.panCard}</FormHelperText>
              )}
            </Grid>
          </>}


          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              * Please ensure all documents are clearly visible.
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Button
            variant="outlined"
            onClick={() => handleNext(true)}
            sx={{
              borderColor: '#0A2472',
              color: '#0A2472',
              '&:hover': { borderColor: '#061551', color: '#061551' }
            }}
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              bgcolor: '#0A2472',
              '&:hover': { bgcolor: '#061551' }
            }}
          >
            Continue to Payment
          </Button>
        </Box>
      </form>
    </Paper>
  );
}

// Payment component
const PaymentComponent = ({ formType, formData, handleNext, handleBack, setFormData, setPaymentStatus }) => {
  // const config = formConfigurations[formType];
  // const [paymentMethod, setPaymentMethod] = useState('card');
  // const [errors, setErrors] = useState({});
  // const [cardDetails, setCardDetails] = useState({
  //   cardNumber: '',
  //   cardName: '',
  //   expiry: '',
  //   cvv: ''
  // });
  const config = formConfigurations[formType];
  const [paymentMethod, setPaymentMethod] = useState('upi'); // 'upi' or 'razorpay'
  const [transactionId, setTransactionId] = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [amount, setAmount] = useState(null);
  const [name, setName] = useState(null);
  const [loading, setLoading] = useState(false);
  console.log("formdata: ", formData);
  useEffect(() => {
    if (formType === 'student') {
      setAmount(500);
      setName(formData.firstName);
    }
    else if (formType === "Registrationforevent") {
      setName(formData.fullName);

      setAmount(200);
    }
    else if (formType === "knowledgepartnersmember") {
      setName(formData.fullName);
      setAmount(1200);

    }
    else {
      // console.log("formData:", formData.noOfShares * 100);
      setName(formData.fullName);
      if (formData?.noOfShares) {
        setAmount(formData.noOfShares * 100);
      }
    }
    // setFormData({ ...formData, [amount]: amount });
  }, [])
  useEffect(() => {
    if (amount) {
      setFormData({ ...formData, amount: amount });

    }
  }, [amount])

  // const handleCardChange = (e) => {
  //   const { name, value } = e.target;
  //   // setCardDetails({
  //   //   ...cardDetails,
  //   //   [name]: value
  //   // });
  // };

  // const validatePayment = () => {
  //   const newErrors = {};
  //   let isValid = true;

  //   if (paymentMethod === 'card') {
  //     if (!cardDetails.cardNumber) {
  //       newErrors.cardNumber = 'Card number is required';
  //       isValid = false;
  //     } else if (!/^\d{16}$/.test(cardDetails.cardNumber)) {
  //       newErrors.cardNumber = 'Please enter a valid 16-digit card number';
  //       isValid = false;
  //     }

  //     if (!cardDetails.cardName) {
  //       newErrors.cardName = 'Name on card is required';
  //       isValid = false;
  //     }

  //     if (!cardDetails.expiry) {
  //       newErrors.expiry = 'Expiry date is required';
  //       isValid = false;
  //     } else if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(cardDetails.expiry)) {
  //       newErrors.expiry = 'Please enter expiry in MM/YY format';
  //       isValid = false;
  //     }

  //     if (!cardDetails.cvv) {
  //       newErrors.cvv = 'CVV is required';
  //       isValid = false;
  //     } else if (!/^\d{3}$/.test(cardDetails.cvv)) {
  //       newErrors.cvv = 'Please enter a valid 3-digit CVV';
  //       isValid = false;
  //     }
  //   }

  //   setErrors(newErrors);
  //   return isValid;
  // };

  const handleRazorpay = async (e) => {
    e.preventDefault();
    const backendUrl = "https://razorpay-backend-xh7f.onrender.com/create-order";

    const {
      idProof,
      addressProof,
      panCard,
      signature,
      photo,
      ...safeFormData
    } = formData;

    setLoading(true);
    try {
      // 🔁 Create Razorpay Order
      const orderRes = await axios.post(backendUrl, {
        amount,
        email: formData.email,
        name: name,
        safeFormData, // for PDF in email
      });

      const { id: order_id, amount: orderAmount, currency } = orderRes.data;

      const options = {
        key: "rzp_live_N8X6rAXpQoBRVo", // Replace with live key on prod
        amount: orderAmount,
        currency,
        name: "NYCS Surat",
        description: config.title || "Membership Payment",
        order_id,
        handler: async function (response) {
          try {
            const db = getFirestore();
            const storage = getStorage();
            const formId = uuidv4();

            // ✅ Save Payment Details
            await addDoc(collection(db, "payments"), {
              amount: orderAmount / 100,
              currency,
              order_id,
              payment_id: response.razorpay_payment_id,
              created_at: new Date(),
              fullName: name,
              email: formData.email || "",
            });

            // ✅ Upload Files
            const fileFields = {
              idProof,
              addressProof,
              passportPhoto: photo,
              signature
            };
            if (formData.formType !== "student" && panCard) {
              fileFields.panCard = panCard;
            }

            const uploadedUrls = {};
            for (const [field, file] of Object.entries(fileFields)) {
              if (file) {
                const storageRef = ref(storage, `applications/${formId}/${field}`);
                await uploadBytes(storageRef, file);
                const downloadURL = await getDownloadURL(storageRef);
                uploadedUrls[field] = downloadURL;
              }
            }

            // ✅ Save Application Form
            await addDoc(collection(db, "applications"), {
              ...safeFormData,
              files: uploadedUrls,
              created_at: new Date(),
              formId,
            });
            // ✅ Send Email to backend with form data and file URLs
            try {
              await axios.post("https://razorpay-backend-xh7f.onrender.com/send-form", {
                safeFormData,
                files: uploadedUrls,
              });
              console.log("📧 Email sent to jananidhi.29surat@gmail.com");
            } catch (emailErr) {
              console.error("📧 Failed to send email:", emailErr);
            }

            console.log("✅ Uploaded successfully.");
            setPaymentStatus("success");  // ✅ CRITICAL for success page
            handleNext();                 // ✅ Navigate to completion screen
          } catch (uploadErr) {
            console.error("🔥 Error after successful payment:", uploadErr);
            alert("Payment succeeded, but something went wrong while saving your data.");
            setPaymentStatus("failure");  // Optional: to handle edge case
            handleNext();                 // Optional: navigate to failure screen
          } finally {
            setLoading(false);            // ✅ Only stop loading after everything
          }
        }
        ,
        prefill: {
          name: formData.fullName,
          email: formData.email || "",
        },
        theme: {
          color: "#0A2472",
        },
        modal: {
          ondismiss: function () {
            // ⛔ User closed payment modal without completing
            console.warn("Payment cancelled or failed.");
            setPaymentStatus("failed");
            handleNext(); // Go to FailureComponent
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      console.error("❌ Payment/initiation error:", error);
      alert("Something went wrong. Please try again.");
      setPaymentStatus("failed");
      handleNext();
    }
  };




  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom>
        Payment Details
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Card variant="outlined" sx={{ mb: 3, bgcolor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>Order Summary</Typography>
          <Typography variant="body1">{config.title}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {formData.firstName} {formData.lastName}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Typography variant="body1">Amount:</Typography>
            <Typography variant="body1" fontWeight="bold">₹{amount}</Typography>
          </Box>
        </CardContent>
      </Card>

      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            px: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              maxWidth: '90%',
            }}
          >
            <CircularProgress />
            <Typography variant="h6" sx={{ mt: 2, width: '100%' }}>
              Processing your payment...
            </Typography>
            <Typography
              variant="body2"
              sx={{ mt: 1, color: 'text.secondary', width: '100%' }}
            >
              Please do not refresh or close the page during this process.
            </Typography>
          </Box>
        </Box>
      )}



      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Payment Method: Razorpay
      </Typography>

      <form onSubmit={handleRazorpay}>
        <Box
          sx={{
            mt: 4,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            gap: 2, // adds spacing between buttons
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            fullWidth={true}
            sx={{
              borderColor: '#0A2472',
              color: '#0A2472',
              '&:hover': { borderColor: '#061551', color: '#061551' }
            }}
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            fullWidth={true}
            sx={{
              bgcolor: '#0A2472',
              '&:hover': { bgcolor: '#061551' }
            }}
          >
            Proceed to Razorpay
          </Button>
        </Box>

      </form>
    </Paper>

  );
};

// Completion component
const CompletionComponent = ({ formType, formData }) => {
  const config = formConfigurations[formType];
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString();
  const referenceId = Math.random().toString(36).substring(2, 10).toUpperCase();

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: '#4CAF50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: 40
          }}
        >
          ✓
        </Box>
      </Box>

      <Typography variant="h5" gutterBottom color="success.main">
        Payment Successful!
      </Typography>

      <Typography variant="body1" paragraph>
        Thank you, {formData.firstName} {formData.lastName}! Your {config.title.toLowerCase()} has been successfully processed.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Your payment details have been sent to your email address.
      </Typography>

      <Card variant="outlined" sx={{ mb: 3, textAlign: 'left', bgcolor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>Receipt</Typography>
          {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}> */}
          {/* <Typography variant="body2">Reference ID:</Typography>
            <Typography variant="body2" fontWeight="bold">{referenceId}</Typography> */}
          {/* </Box> */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2">Date:</Typography>
            <Typography variant="body2">{formattedDate}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2">Name:</Typography>
            <Typography variant="body2">{formData.firstName} {formData.lastName}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2">Email:</Typography>
            <Typography variant="body2">{formData.email}</Typography>
          </Box>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body1" fontWeight="bold">Amount Paid:</Typography>
            <Typography variant="body1" fontWeight="bold">₹{formData.amount}</Typography>
          </Box>
        </CardContent>
      </Card>

      <Typography variant="body2" color="text.secondary" paragraph>
        A confirmation email with all details has been sent to {formData.email}.
      </Typography>

      <Button
        variant="contained"
        sx={{
          bgcolor: '#0A2472',
          '&:hover': { bgcolor: '#061551' }
        }}
        onClick={() => window.location.reload()}
      >
        Return to Home
      </Button>
    </Paper>
  );
};
const FailureComponent = ({ email }) => (
  <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          bgcolor: '#f44336',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: 40
        }}
      >
        ✗
      </Box>
    </Box>
    <Typography variant="h5" gutterBottom color="error">
      Payment Failed
    </Typography>
    <Typography variant="body1" paragraph>
      Unfortunately, your payment did not go through.
    </Typography>
    <Typography variant="body2" color="text.secondary">
      If any amount was deducted, it will be auto-refunded. For help, contact us at jananidhi.29surat@gmail.com.
    </Typography>
    <Button
      variant="contained"
      sx={{ mt: 3, bgcolor: '#0A2472', '&:hover': { bgcolor: '#061551' } }}
      onClick={() => window.location.reload()}
    >
      Try Again
    </Button>
  </Paper>
);


export default function FormApplication() {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [formType, setFormType] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [formData, setFormData] = useState({});

  const steps = ['Form Type', 'Application Details', 'Document Upload', 'Payment', 'Completion'];

  const handleNext = (goBack = false) => {
    if (goBack) {
      setActiveStep(activeStep - 1);
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
        <Box sx={{ mb: 4 }}>
          <Stepper
            activeStep={activeStep}
            orientation="horizontal"
            sx={{
              flexWrap: 'wrap',
              rowGap: 2,
              justifyContent: 'center',
              '& .MuiStep-root': {
                flex: { xs: '1 1 100%', sm: '1' } // Full width on mobile, equal width on larger screens
              }
            }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {activeStep === 0 && (
          <FormTypeSelection
            formType={formType}
            setFormType={setFormType}
            termsAccepted={termsAccepted}
            setTermsAccepted={setTermsAccepted}
            handleNext={handleNext}
          />
        )}

        {activeStep === 1 && (
          <FormComponent
            formType={formType}
            formData={formData}
            setFormData={setFormData}
            handleNext={handleNext}
          />
        )}
        {activeStep === 2 && (
          <DocumentType
            formType={formType}
            formData={formData}
            setFormData={setFormData}
            handleNext={handleNext}
          />
        )}

        {activeStep === 3 && (
          <PaymentComponent
            formType={formType}
            formData={formData}
            handleNext={handleNext}
            setFormData={setFormData}
            handleBack={handleBack}
            setPaymentStatus={setPaymentStatus}
          />
        )}

        {activeStep === 4 && (
          paymentStatus === "success" ? (
            <CompletionComponent formType={formType} formData={formData} />
          ) : (
            <FailureComponent email={formData.email} />
          )
        )}

      </Container>


    </Box>
  );
}
// try {
//   const orderRes = await axios.post(backendUrl, {
//     amount: formData.noOfShares * 100 * 100, // ₹100 per share, converted to paise
//     currency: "INR",
//     receipt: `receipt_${Date.now()}`,
//   });

//   const { id: order_id, amount: orderAmount, currency } = orderRes.data;

//   const options = {
//     key: "YOUR_KEY_ID", // Replace with your Razorpay public key
//     amount: orderAmount,
//     currency,
//     name: "NYCS Surat",
//     description: config.title,
//     order_id,
//     handler: async function (response) {
//       // Store payment details in Firestore
//       await addDoc(collection(db, "payments"), {
//         amount: orderAmount / 100,
//         currency,
//         order_id,
//         payment_id: response.razorpay_payment_id,
//         created_at: new Date(),
//         fullName: `${formData.firstName} ${formData.lastName}`,
//         email: formData.email || "",
//         noOfShares: formData.noOfShares,
//       });

//       alert("Payment successful!");
//       handleNext();
//     },
//     prefill: {
//       name: `${formData.firstName} ${formData.lastName}`,
//       email: formData.email || "",
//     },
//     theme: {
//       color: "#0A2472",
//     },
//   };

//   const rzp = new window.Razorpay(options);
//   rzp.open();
// } catch (error) {
//   console.error("Payment failed", error);
//   alert("Failed to initiate payment. Try again.");
// }